<template>
    <v-row align="center" justify="center">
        <template v-for="price in prices">
            <v-card class="mx-auto" max-width="500">
                <v-img :src="price.img" height="200px"></v-img>

                <v-card-title>
                    {{ price.name }}
                </v-card-title>

                <div style="font-size: 36px; font-weight: bold; margin-left: 16px; ">
                    {{ price.price }}
                </div>


                <v-card-subtitle>
                    {{ price.description }}
                </v-card-subtitle>


                <v-card-text class="">

                    {{ price.detaildescription }}
                    <v-list dense disabled>
                        <v-list-item v-for="(item, i) in price.features" :key="i">
                            <v-list-item-icon>
                                <v-icon v-text="item.icon"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="text-subtitle-2" v-text="item.text"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>

                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions>
                    <b v-if="hasSubscription(currentUser)" color="blue lighten-2" text>
                        You already haven an active plan
                    </b>
                    <v-btn v-if="currentUser&& 'deactivation_date' in currentUser && currentUser.deactivation_date && !hasSubscription(currentUser)" @click="clickedPaymentLink(price)"  color="blue lighten-2" text>Plan
                        expired, <router-link to="/pricing">buy new
                            access</router-link>)</v-btn>

                    <v-btn v-else-if="currentUser" @click="clickedPaymentLink(price)" color="blue lighten-2" text>
                        Get Started
                    </v-btn>
                    <v-btn v-else @click="clickedPaymentLink(price)" color="blue lighten-2" text>
                        Create an account first, then pay
                    </v-btn>
                    {{ paymentLink }}
                    <v-spacer></v-spacer>

                </v-card-actions>


            </v-card>
        </template>
    </v-row>
</template>
  

<script>

import { commonmethods } from "@/common/common";
import { mapGetters } from "vuex";
import { permissionchecks } from "@/common/permissions";
import ApiUser from "@/common/api/user";

export default {
    name: "pricing",
    data() {
        return {
            show: true,
            paymentLink: "",
            prices: [
                {   // production: https://buy.stripe.com/14k7vMb6R3jpgzm5kw
                    // dev: https://buy.stripe.com/test_dR603GgIBaPO1dS3ch
                    payment_link: "https://buy.stripe.com/test_dR603GgIBaPO1dS3ch", // dev
                    price: "150$",
                    name: "1 Year Full Access",
                    description: "One-time one year full access",
                    img: 'https://cdn.vuetifyjs.com/images/cards/sunshine.jpg',
                    detaildescription: "Access the whole PacketSafari PCAP archive including many PCAPs with a well-written short description, Capture-the-Flags (CTFs) PCAPs and case-studies for one year",
                    features: [

                        {
                            icon: "check",
                            text: "Access the whole PacketSafari archive"
                        },
                        {
                            icon: "check",
                            text: "Maximum upload file size for PCAPs 5 MB instead 1MB"
                        },
                        {
                            icon: "check",
                            text: "Total storage of 200MB"
                        },
                        {
                            icon: "check",
                            text: "No automatic renewal"
                        }
                    ]
                }]
        };
    },
    created: function () { },
    mounted() { },
    mixins: [permissionchecks, commonmethods],
    computed: {
        ...mapGetters(["currentAnalysis", "currentUser", "error"]),
    },
    watch: {},
    methods: {
        uuidv4: function () {
            return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },
        clickedPaymentLink: function (price) {
            if (!this.currentUser) {
                this.$router.push({ name: "Register" });
            } else {
                this.generatePaymentLink(price)
            }

        },
        generatePaymentLink: async function (price) {
            let lnk = price.payment_link
            let stripe_client_reference_id = this.uuidv4()

            try {
                const value = await ApiUser.setcheckoutsession(stripe_client_reference_id)
            } catch (e) {
                console.error("Could not set checkou session id")
                return
            }

            lnk = lnk + `?prefilled_email=${this.currentUser.email}&client_reference_id=${stripe_client_reference_id}`
            this.paymentLink = lnk
            //window.location.href = lnk
        }
    },
};
</script>
  
<style ></style>
  